export default "__VITE_ASSET__DXvAc2_V__"